import { useLocation } from "react-router-dom";

// Soft UI Dashboard React Components
import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
import RecentActivity from "./components/RecentActivity";
import WorkflowActivities from "./components/WorkflowActivities";
import GetStarted from "./components/GetStarted";
import MyTeam from "./components/MyTeam";
import Footer from "cxfcomponents/Footer";
import "./styles.css";

function Overview() {
  const { pathname } = useLocation();

  return (
    <SoftBox>
      {pathname === "/analytics/" && (
        <SoftBox p={2}>
          <Grid container spacing={3} sx={{ height: "285px" }}>
            <Grid size={{ xs: 12, lg: 12 }}>
              <WorkflowActivities />
              <br />
              <Footer />
              <br />
            </Grid>
          </Grid>
        </SoftBox>
      )}
      {pathname === "/home" && (
        <>
          {/* <SoftBox p={2}>
            <SoftBox>
              <SoftTypography variant="h5" fontWeight="regular">
                {`Welcome back, ${userData?.first_name}`}
              </SoftTypography>
            </SoftBox>
          </SoftBox> */}
          <div className="home-dashboard">
            <SoftBox>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                  <GetStarted />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                  <MyTeam />
                </Grid>
                <Grid size={{ xs: 12, md: 12, lg: 4 }}>
                  <RecentActivity />
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox mt={2}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, lg: 12 }}>
                  <WorkflowActivities />
                </Grid>
              </Grid>
            </SoftBox>
          </div>
        </>
      )}
    </SoftBox>
  );
}

export default Overview;
